import { DotSeriesTooltip } from './DotSeriesTooltip/DotSeriesTooltip.js';
import { RectSeriesTooltip } from './RectSeriesTooltip/RectSeriesTooltip.js';
import { useContentState } from '../../store/selectors.js';
import { DOT_VARIANT, RECT_VARIANT } from '../../types/xy-chart-internals.js';

export const XYChartTooltipContent = () => {
  const content = useContentState();

  switch (content.type) {
    case RECT_VARIANT:
      return (
        <RectSeriesTooltip
          datapoint={content.datapoint}
          series={content.series}
        />
      );
    case DOT_VARIANT:
      return (
        <DotSeriesTooltip
          datapoint={content.datapoint}
          series={content.series}
        />
      );

    default:
      return null;
  }
};
